module.exports = __webpack_public_path__ + "static/media/linkedin.46e0db48.svg";